import React from 'react';
import './Header.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

const Header = function(props) { 
    return (
        <Navbar fixed="top" bg="light" variant="light" expand="lg">
            <Navbar.Brand href="#homey">
                <img className = "header-logo" src={"img/logos/standard-logo-files/black-on-transparent.png"}></img>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Nav className="mr-auto_disable">
                    <Nav.Link href="#home">Home</Nav.Link>
                    <NavDropdown className="" title="Services" id="basic-nav-dropdown">
                        <NavDropdown.Item href="#intruderdetection">Intruder Detection</NavDropdown.Item>
                        <NavDropdown.Item href="#cctv">CCTV</NavDropdown.Item>
                        <NavDropdown.Item href="#firealarm">Fire Alarms</NavDropdown.Item>
                        <NavDropdown.Item href="#accesscontrol">Access Control</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="#contact">Contact</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default Header;